import BaseStore from './base'

const schema = {
  campaignID: String,
  emitterID: String,
  timestamp: Number,
  type: String,
  infos: {
    field: String
  }
}

export default class EventStore extends BaseStore {
  static get storageKey () { return 'tracker-events' }
  static get apiFunction () { return 'postEvents' }
  static get rawSchema () { return schema }
}
